<template>
  <div class="courseware" :style="{height:windowHeight+'px'}">
    <Header></Header>
    <div class="detail-wrapper" style="padding-top:70px; height:100%;">
      <div class="bg-white-wrapper">
        <div class="container location">
          <Breadcrumb class="breadcrumb" separator="»">
            <BreadcrumbItem to="/">首页</BreadcrumbItem>
            <BreadcrumbItem>学习中心</BreadcrumbItem>
            <BreadcrumbItem :to="{ name: 'Study', params: { cid: cid } }">{{ categoryInfo.title }}</BreadcrumbItem>
            <BreadcrumbItem>教材讲义</BreadcrumbItem>
          </Breadcrumb>
        </div>
      </div>

      <div class="container ware-list">
        <div class="title" v-if="categoryInfo.dl_adr">内部教材</div>
        <div class="ware-item" v-if="categoryInfo.dl_adr">
          <div class="ware-title">
            <span class="ware-text">{{ categoryInfo.title }}-内部教材</span>
          </div>
          <a :href="categoryInfo.dl_adr" class="ware-down" target="_blank">
            下载
          </a>
        </div>
        <div class="title">课程讲义</div>
        <div class="ware-item" v-if="dataList.length > 0" v-for="(item, index) in dataList" :key="index">
          <div class="ware-title">
            <span class="ware-text">{{ item.title }}</span>
          </div>
          <a :href="item.dl_adr" class="ware-down" target="_blank">
            下载
          </a>
        </div>
        <div class="practice-nodata" v-else>
          <img src="../../assets/images/nodata-video.png" alt="暂无资料" />
          <p class="am-margin-top">暂无讲义</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    getCategoryInfo,
    getCourseWare,
  } from "../../api/api";
  import Header from '../../components/header.vue'
  export default {
    data() {
      return {
        cid: 0,
        categoryInfo: [],
        dataList: [],
        windowHeight: document.documentElement.clientHeight
      };
    },
    mounted() {
      let cid = this.$route.params.cid;
      if (!cid) {
        this.$Message.error("参数错误");
        return;
      }
      this.cid = cid;
      this.getCourseWare();
    },
    methods: {
      getCourseWare() {
        getCourseWare({cid:this.cid}).then((res) => {
          //console.log(res);
          if (res.code === 1) {
            this.categoryInfo = res.data.course;
            this.dataList = res.data.list;
          }
        });
      },
    },
    components: {
      Header
    },
  };
</script>

<style lang="less" scoped>
  .location {
    padding: 1rem 0;
  }

  .ware-list {
    padding-top: 20px;
    .title{
      margin-bottom: 15px;
      font-weight: bold;
    }
  }

  .ware-item {
    padding: 10px 16px;
    background: #fff;
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .ware-title {
      flex: 1;

      .ware-icon {
        margin-right: 10px;
      }

      .ware-text {}
    }

    .ware-down {
      flex: 0 0 48px;
      width: 48px;

      img {
        width: 48px;
        height: 48px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/exercise/CourseWare.vue